import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultTo, find, findIndex, propEq, path } from 'ramda';

import styles from './styles.m.scss';

import { handleErrorBase, handleSuccessBase } from '../../../../../util/forms';
import { toCurrency } from '../../../../../util/helpers';
import { apiGetModuleDiscount } from '../../../../../api/discount';
import { apiPayModuleFees, apiUpdateRegistration } from '../../../../../api/registration';

import StripeCheckout from '../../../../../components/StripeCheckout';
import DiscountForm from '../../../../../components/DiscountForm';

const propTypes = {
  certification: PropTypes.object,
  module: PropTypes.object,
  updateRegistration: PropTypes.func,
  setStep: PropTypes.func,
  step: PropTypes.number,
  user: PropTypes.object,
};

class Module extends Component {
  state = {
    price: null,
    discount: {},
  };

  renderNeedsPayment = (nextModule) => {
    const { registration, updateRegistration, module } = this.props;
    const { price, discount } = this.state;
    const modulePrice = price == null ? nextModule.price : price;

    return (
      <div>
        <h2 className={styles.stepHeader}>Congratulations on completing {module.name}.</h2>
        <p>
          In order to start {nextModule.name}, please click the button below to pay {toCurrency(modulePrice)}
        </p>

        <DiscountForm
          discount={discount}
          checkDiscount={(discountCode) => apiGetModuleDiscount({ discountCode, moduleId: nextModule.id })}
          update={(data) => {
            this.setState({ price: data.payment / 100, discount: defaultTo({}, data.discount) });
          }}
        />

        <div className="d-flex justify-content-end">
          <StripeCheckout
            name="Sage Financial Solutions"
            description="Module Payment"
            amount={Number(modulePrice)}
            pay={(token, overrides = {}) =>
              apiPayModuleFees(registration.id, { token, moduleId: nextModule.categoryId, ...overrides })
                .then(({ data }) => updateRegistration(data))
                .then(() => handleSuccessBase())
                .catch((err) => handleErrorBase(`Could not pay for ${nextModule.name}`))
            }
          />
        </div>
      </div>
    );
  };

  renderAlreadyPassed = (nextModule) => {
    const { module, registration, name, updateRegistration, setStep, step } = this.props;

    return (
      <div>
        <h2 className={styles.stepHeader}>Congratulations on completing {module.name}.</h2>
        <p>Click the button below to start {nextModule.name}</p>
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() =>
              apiUpdateRegistration(registration.id, { stepName: name })
                .then(({ data }) => updateRegistration(data))
                .then(() => handleSuccessBase())
                .then(() => setStep(step + 1))
                .catch((err) => handleErrorBase())
            }
          >
            Next
          </button>
        </div>
      </div>
    );
  };

  renderLastModule = () => {
    const { module, registration, name, updateRegistration, setStep, step } = this.props;

    return (
      <div>
        <h2 className={styles.stepHeader}>Thank you for registering for {module.name}.</h2>
        <p>The next steps will be completed while you are taking your course on Canvas.</p>
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() =>
              apiUpdateRegistration(registration.id, { stepName: name })
                .then(({ data }) => updateRegistration(data))
                .then(() => handleSuccessBase())
                .then(() => setStep(step + 1))
                .catch((err) => handleErrorBase())
            }
          >
            Next
          </button>
        </div>
      </div>
    );
  };

  renderWaiting = () => {
    const { module } = this.props;

    return (
      <div>
        <h2 className={styles.stepHeader}>Thank you for registering for {module.name}.</h2>
        <p>In order to obtain your badge and continue on to the next module, please finish your course on Canvas.</p>
      </div>
    );
  };

  render() {
    const { certification, module, registration, user } = this.props;
    let nextModuleIndex = findIndex(propEq('categoryId', module.categoryId), certification.trainings);

    if (nextModuleIndex == certification.trainings.length - 1) return this.renderLastModule();

    if (nextModuleIndex != -1) nextModuleIndex++;
    const nextModule = defaultTo({}, path(['trainings', nextModuleIndex], certification));
    const nextModulePayment = defaultTo({}, find(propEq('categoryId', nextModule.categoryId), registration.trainings));

    const waitingOnPayment = nextModulePayment.transactionId == null;
    const alreadyPassed = find(propEq('trainingId', module.categoryId), user.userTrainings);

    if (alreadyPassed && waitingOnPayment) return this.renderNeedsPayment(nextModule);
    if (alreadyPassed) return this.renderAlreadyPassed(nextModule);
    return this.renderWaiting();
  }
}

Module.propTypes = propTypes;

export default Module;
